/**
 * "Hide the mascot while I share my screen in Teams" (owner request 2026-10-13): one native setting in the desktop agent
 * (UserPrefs, off by default), shown in Settings › General › Appearance. While it is on, the floating mascot leaves the
 * screen the moment Teams starts sharing it and comes back by himself when the share ends; the chat window stays as it
 * is. The widget never keeps a copy of its own: the desktop shell relays the agent's snapshot as the
 * `gyro:mascot-share-hide` DOM event, the widget asks for it with `gyro:mascot-share-hide-ready` once the control mounts,
 * and asks for a change with `gyro:mascot-share-hide-set` ({ enabled: boolean }); the agent answers every change, and
 * every share start or end, with a new snapshot. On every other surface (the web widget, the Office pane) the host never
 * answers, and the control is not shown.
 */
export const MASCOT_SHARE_HIDE_EVENT = 'gyro:mascot-share-hide';
export const MASCOT_SHARE_HIDE_READY_EVENT = 'gyro:mascot-share-hide-ready';
export const MASCOT_SHARE_HIDE_SET_EVENT = 'gyro:mascot-share-hide-set';
export const MASCOT_SHARE_HIDE_LABEL = 'Hide the mascot while I share my screen in Teams';
export const MASCOT_SHARE_HIDE_DESCRIPTION = 'When you start sharing your screen in a Teams meeting, the desktop mascot disappears until the share ends. The chat window stays as it is.';
/** How long the control waits for the desktop agent's first snapshot before it decides the host has no such setting. */
export const MASCOT_SHARE_HIDE_WAIT_MS = 5_000;
/** The agent's snapshot, exactly: every field of its kind, nothing else read. Null for anything else. */
export function parseMascotShareHideSnapshot(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        return null;
    const record = value;
    if (record.available !== true || typeof record.enabled !== 'boolean' || typeof record.persisted !== 'boolean'
        || typeof record.sharing !== 'boolean' || typeof record.hidden !== 'boolean')
        return null;
    return { available: true, enabled: record.enabled, persisted: record.persisted, sharing: record.sharing, hidden: record.hidden };
}
/**
 * What Settings says under the switch: that a share is on right now and what the mascot is doing about it, or that the
 * last save failed. Null when there is nothing to explain.
 */
export function mascotShareHideExplanation(snapshot) {
    if (!snapshot.persisted)
        return 'Your choice could not be saved on this computer. It applies until Gyro restarts.';
    if (!snapshot.enabled || !snapshot.sharing)
        return null;
    return snapshot.hidden
        ? 'Sharing now: the mascot is hidden until the share ends.'
        : 'Sharing now. The mascot hides at the start of the next share.';
}
//# sourceMappingURL=mascotShareHide.js.map